// API 호출별 timeout (ms). Vue.auth.getBearerHeader(timeout)에 넘긴다.
// 인자가 없거나 1000 이하이면 헬퍼가 기본 30초로 되돌리므로 반드시 ms 단위로 전달할 것.

// Playback 호출은 브릿지가 영상을 찾아 돌려줄 때까지 서버가 대기하므로(proxy 쿼리 timeout=60)
// 공통 기본값(30초)보다 길게 잡는다. 서버 대기 시간과 같은 60초.
export const PLAYBACK_API_TIMEOUT_MS = 60 * 1000
